// import { faHome, faLock } from '@fortawesome/free-solid-svg-icons'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import NavBar from './components/NavBar'
import Incidents from './components/Incidents/Incidents'
import IncidentDetail from './components/Incidents/IncidentDetail/IncidentDetail'
import Indicators from './components/Indicators/Indicators'
import styled from 'styled-components'

const Wrapper = styled.div`
  height: 100%;
`

const App: React.FC = () => {
  return (
    <Router>
      <NavBar />
      <Switch>
        <Wrapper>
          <Route
            exact
            path="/"
            component={(): JSX.Element => <p>Dashboard</p>}
          />

          <Route
            exact
            path="/incidents/:id/:tab"
            component={(): JSX.Element => <IncidentDetail />}
          />
          <Route
            exact
            path="/incidents"
            component={(): JSX.Element => <Incidents />}
          />
          <Route
            exact
            path="/indicators"
            component={(): JSX.Element => <Indicators />}
          />
          <Route
            exact
            path="/events"
            component={(): JSX.Element => <p>Events</p>}
          />
          <Route
            exact
            path="/settings"
            component={(): JSX.Element => <p>Settings</p>}
          />
        </Wrapper>
      </Switch>
    </Router>
  )
}

export default App
